import React, { createContext, Component } from 'react';
import axios from 'axios';
import { API_HOST } from '../consts';
import { withRouter } from 'react-router-dom';

export const UserContext = createContext({
  id: '',
  name: '',
  username: '',
  email: '',
  photo: '',
  is_staff: false,
});

const FORCED_CHANGE_PATH = '/alterar-senha-obrigatorio';

const withUser = (WrappedComponent) => {
  class Hoc extends Component {
    state = {
      id: '',
      username: '',
      email: '',
      name: '',
      photo: '',
      is_staff: false,
      requirePasswordChange: false,
    };

    componentDidMount() {
      this.fetchUser();
    }

    componentDidUpdate(prevProps) {
      const { location } = this.props;
      const { requirePasswordChange } = this.state;

      if (
        requirePasswordChange &&
        location.pathname !== FORCED_CHANGE_PATH &&
        prevProps.location.pathname !== location.pathname
      ) {
        this.props.history.replace(FORCED_CHANGE_PATH);
      }
    }

    fetchUser = () => {
      return axios.get(`${API_HOST}/login/users/me`).then((response) => {
        const requirePasswordChange = response.data.require_password_change;

        if (
          requirePasswordChange &&
          this.props.location.pathname !== FORCED_CHANGE_PATH
        ) {
          this.props.history.replace(FORCED_CHANGE_PATH);
        }

        this.setState({
          id: response.data.id,
          username: response.data.username,
          email: response.data.email,
          name: response.data.nome,
          photo: response.data.photo_url,
          is_staff: response.data.is_staff,
          requirePasswordChange,
        });
      });
    };

    render() {
      return (
        <UserContext.Provider value={{ ...this.state, refreshUser: this.fetchUser }}>
          <WrappedComponent user={this.state} />
        </UserContext.Provider>
      );
    }
  }

  Hoc.propTypes = Component.propTypes;

  return withRouter(Hoc);
};

export default withUser;
